'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SITE_KEY = 'cw_manage_site';

var SiteStorageManager = function () {
  function SiteStorageManager() {
    (0, _classCallCheck3.default)(this, SiteStorageManager);
  }

  (0, _createClass3.default)(SiteStorageManager, null, [{
    key: 'get',
    value: function get() {
      return localStorage.getItem(SITE_KEY);
    }
  }, {
    key: 'clear',
    value: function clear() {
      localStorage.removeItem(SITE_KEY);
    }
  }, {
    key: 'set',
    value: function set(site) {
      localStorage.setItem(SITE_KEY, site);
    }
  }]);
  return SiteStorageManager;
}();

exports.default = SiteStorageManager;


//////////////////
// WEBPACK FOOTER
// ./~/cw-ui-core/lib/components/authentication/SiteStorageManager.js
// module id = 322
// module chunks = 10